import React, { Component } from 'react'
import { Button, Container, Row, Col, Card, CardBody, CardHeader, Alert, CardGroup } from 'reactstrap'
import welcome from '../../images/mp-online-beta-welcome-image.svg'
import { Email, ConfirmEmail } from './RequestPasswordResetComps'
import { BeatLoader } from 'react-spinners'
import validatePasswordResetReq from '../../helpers/users/validatePasswordResetReq'
import values from 'mout/object/values'
import requestReset from '../../helpers/users/requestReset';

class RequestPasswordReset extends Component {

  state = {
    email: '',
    confirmEmail: '',
    emailErr: '',
    confirmEmailErr: '',
    saved: false,
    saving: false,
    savingErr: '',
  }

  onChg = ({ target }) => this.setState({ [target.name]: target.value })

  handleClick = () => {
    const { email, confirmEmail } = this.state
    this.setState({
      emailErr: '',
      confirmEmailErr: '',
    })

    // validation
    const validation = validatePasswordResetReq(email, confirmEmail)
    if (validation) {
      this.setState({ [Object.keys(validation)[0]]: values(validation)[0] })
      return
    }
    this.setState({ saving: true, })
    requestReset(email)
      .then((res) => {
        const response = JSON.parse(res)
        if (response.error) throw response.error
        this.setState({
          saving: false,
          saved: true,
        })

      })
      .catch((err) => {
        console.log('err', err)
        this.setState({
          saving: false,
          savingErr: err
        })
      })

  }

  render() {
    const alertcolor = 'warning';
    const {
      email,
      confirmEmail,
      emailErr,
      confirmEmailErr,
      saved,
      saving,
      savingErr } = this.state
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="mb-0" style={{ "height": "auto" }}  >
                <Card className="text-white col-sm-5  py-5 d-md-down-none" style={{ 'backgroundColor': '#194250', 'borderTopRightRadius': '0', 'borderBottomRightRadius': '0' }}>
                  <CardBody className="card-body text-center">
                    <div style={{ "marginTop": " 110px" }}>
                      <p><img src={welcome} alt="MasteryPrep Logo" /></p>
                    </div>
                  </CardBody>
                </Card>
                <Card className="p-4 " style={{ 'borderTopLeftRadius': '0', 'borderBottomLeftRadius': '0' }}>
                  <div className='reset-password-header'>
                    <h5>Reset Password</h5>
                  </div>
                  <CardBody>

                    <div className="reset-password-msg">
                      Request a password reset by entering your email address below:
                    </div>

                    <Email
                      val={email}
                      onChg={this.onChg}
                      saved={saved}
                      err={emailErr}
                    />

                    <ConfirmEmail
                      val={confirmEmail}
                      onChg={this.onChg}
                      saved={saved}
                      err={confirmEmailErr}
                    />

                    <div className='reset-password-button'>
                      <Button onClick={this.handleClick} color="primary" className="px-4">
                        {!saving ? 'Request Reset' : <BeatLoader loading={true} color={'#ffffff'}/>}
                      </Button>
                    </div>

                    {!!emailErr && <Alert color={alertcolor}>{emailErr}</Alert>}
                    {!!confirmEmailErr && <Alert color={alertcolor}>{confirmEmailErr}</Alert>}
                    {!!saved && <Alert>Reset request sent.</Alert>}
                    {!!savingErr && <Alert color={alertcolor}>{savingErr}</Alert>}

                    <span className="reset-password-msg" style={{ fontSize: '13px' }}>
                      <b>Note</b>:
                      if you need to reset your password,
                      but you are using a username and not an email address to sign in to your account,
                      please contact your teacher or administrator for assistance.
                   </span>
                   
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default RequestPasswordReset


// WEBPACK FOOTER //
// ./src/components/Users/RequestPasswordReset.js